import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import './Panel.css';
import {SideBar} from "../SideBar/SideBar.js";
import { Navbar } from '../Navbar/Navbar.js';

const FactPanel = () => {
  const [funFacts, setFunFacts] = useState([]);

  useEffect(() => {
    const fetchFunFacts = async () => {
      try {
        const response = await axiosInstance.get('/fact/content');
        setFunFacts(response.data);
      } catch (error) {
        console.error('Error fetching fun facts:', error);
      }
    };

    fetchFunFacts();
  }, []);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFacts = [...funFacts];
    updatedFacts[index][name] = value;
    setFunFacts(updatedFacts);
  };

  const handleSubmit = async (index) => {
    try {
      const response = await axiosInstance.put(`/fact/${funFacts[index]._id}`, funFacts[index]);
      if (response.status === 200) {
        console.log('Fun fact updated successfully');
      } else {
        console.error('Update failed:', response.statusText);
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };

  return (

    <>
    <div className="flex">
    <SideBar />
    <div className="flex-1 h-screen p-6 overflow-auto bg-gray-100"> 
      <div className="max-w-3xl mx-auto panel-container">
        <div className="panel-form bg-white p-8 rounded-lg shadow-xl">
          <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">Fun Facts Panel</h2>
          {funFacts.map((fact, index) => (
            <div key={index} className="space-y-6">
              <input
                type="number"
                name="number"
                value={fact.number}
                onChange={(e) => handleChange(index, e)}
                placeholder="Number"
                className="w-full p-4 mt-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required />
              <input
                type="text"
                name="label"
                value={fact.label}
                onChange={(e) => handleChange(index, e)}
                placeholder="Label"
                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"

                required />
              <button className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300" onClick={() => handleSubmit(index)}>Update</button>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div></>
  );
};

export default FactPanel;